// extracted by mini-css-extract-plugin
export default {"overview":"OverviewCard_overview__kqR12","title":"OverviewCard_title__BIC7y","statusButton":"OverviewCard_statusButton__5pSf+"};